import { Box, Card, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { PaymentStatusChip } from '@/components';
import { formatDecimalValueNumberInput, Order } from '@/core';
import palette from '@/theme/palette';

export const OrderDetailsCard = ({ order }: { order: Order }) => {
  const { t } = useTranslation();
  const { id, status, created_at, order_number, is_takeout, total_price, total_taxed_price } =
    order;
  return (
    <Card
      sx={{
        maxWidth: '800px',
        width: '100%',
        backgroundColor: palette.surface.white,
        padding: 2,
      }}
    >
      <Stack direction={'column'} gap={2}>
        <Stack direction="row" justifyContent={'space-between'} alignItems="center" gap={2}>
          <Stack direction="row" gap={2} alignItems="end" justifyContent={'center'}>
            <Typography variant="h2">{t('ORDER.ID')}:</Typography>
            <Typography variant="h2" color={palette.primary.main}>
              {id}
            </Typography>
          </Stack>
          <PaymentStatusChip status={status} />
        </Stack>
        <Stack
          direction={'row'}
          justifyContent={'start'}
          alignItems={'center'}
          gap={4}
          sx={{
            '.MuiTypography-body1': {
              fontStyle: 'italic',
            },
            '.MuiTypography-body1:first-of-type': {
              color: palette.text.secondary,
            },
          }}
        >
          <Stack direction={'column'} gap={1}>
            <Typography variant="body1">{t('ORDER.DATE_AND_TIME')}</Typography>
            <Typography variant="body1">
              {dayjs(created_at).format('DD.MM.YYYY, HH:mm:ss')}
            </Typography>
          </Stack>
          <Stack direction={'column'} gap={1}>
            <Typography variant="body1">{t('ORDER.ORDER_NUMBER')}</Typography>
            <Typography variant="body1">{order_number}</Typography>
          </Stack>
          <Stack direction={'column'} gap={1}>
            <Typography variant="body1">{t('ORDER.TYPE')}</Typography>
            <Typography variant="body1">
              {is_takeout ? t('ORDER.TAKEOUT') : t('ORDER.EAT_IN')}
            </Typography>
          </Stack>
        </Stack>
        <Box sx={{ width: '100%', height: '1px', bgcolor: palette.border.default }} />
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={2}>
          <Typography variant="body1" color={palette.text.secondary}>
            {t('ORDER.PRICE_WITHOUT_TAX')}
          </Typography>
          <Typography variant="body1">
            {formatDecimalValueNumberInput(total_price, 2)} {t('GLOBAL.CZ_CURRENCY')}
          </Typography>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={2}>
          <Typography variant="body1" color={palette.text.secondary}>
            {t('ORDER.PRICE_TOTAL')}
          </Typography>
          <Typography variant="h2">
            {formatDecimalValueNumberInput(total_taxed_price, 2)} {t('GLOBAL.CZ_CURRENCY')}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
